import { connect } from "react-redux";

import PaddleCheckout from "./PaddleCheckout";
import { updateOrganizationSubscription } from "../subscriptionActions";
import { updateDiscountUsedStatus } from "../../AppOnboarding/appOnboardingActions";

const mapStateToProps = (state) => ({
  selectedOrganization: state.organization.selectedOrganization,
  appOnboardingState: state.appOnboarding,
});

const mapDispatchToProps = (dispatch) => ({
  updateOrganizationSubscription: (payload) =>
    dispatch(updateOrganizationSubscription(payload)),
  updateDiscountUsedStatus: (organizationId, discountUsed) =>
    dispatch(updateDiscountUsedStatus(organizationId, discountUsed)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaddleCheckout);
